@if (schema()) {
  <mobi-ld-schema [schema]="schema()" />
}
<mobi-product-layout
  [entity]="entity()"
  [isAssetManagement]="true"
  [contentLinksOverride]="contentLinks()"
  [hasOverview]="false"
/>
